import React from "react";

export default function HazardSelect({ options = [], selectedId = "", disabled = false, onChange }) {
  return (
    <select
      className="mb-run-cellSelect"
      value={String(selectedId || "")}
      disabled={disabled}
      onChange={(event) => onChange?.(String(event.target.value || ""))}
    >
      <option value="">(None)</option>
      {options.map((row) => (
        <option key={row.id} value={row.id}>{row.name}</option>
      ))}
    </select>
  );
}
